import { PageLayout } from '~/components/PageLayout/PageLayout';
import { UserListTable } from './components/user-list-table';
import { Button } from '~/components/Button/Button';
import { Link } from '~/components/Link/Link';
import { useUserListQuery } from '../queries';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  const { data = [], isLoading } = useUserListQuery();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Användare" />
        <Link to="create">
          <Button>Skapa ny användare</Button>
        </Link>
      </PageLayout.Header>

      <UserListTable users={data} isLoading={isLoading} />
    </Fragment>
  );
}
